const RandomSampleFormModel = {
  formField: {
    PercentageOfActiveUsers: {
      name: 'PercentageOfActiveUsers',
      label: 'Percentage of active users*',
      requiredErrorMsg: 'Percentage of active users is required.',
      typeErrorMsg: 'Percentage of active users must be number.'
    },
    NumberOfUsersInSchemeYear: {
      name: 'NumberOfUsersInSchemeYear',
      label: 'Number of relevant users'
    },
    NumberOfUsersInTheSample: {
      name: 'NumberOfUsersInTheSample',
      label: 'Number of users in the sample'
    },
    NumberOfYearsToCheckPreviousValidations: {
      name: "NumberOfYearsToCheckPreviousValidations",
      label: "Exclude Users that have been verified in the previous number of years*",
      requiredErrorMsg: 'Exclude Users that have been verified in the previous number of years is required.'
    }
  }
};

export default RandomSampleFormModel;
